import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useRouteMatch } from 'react-router-dom';
import { getCurrentFormattedDateNY } from '../../../global/helpers/form-data-helper';
import { getCurrencyFormat } from '../../../global/helpers/format-helpers';
import { YesNoIndicators } from '../../../global/models/api-model';
import { TcsmStates } from '../../../root/tcsm-model';
import { DcData, MyCpgPodsSettings, MyCpgPodsTypes, PodContent } from '../mycpg-pod-models';
import { PodGridContent } from './pod-grid-content';
import { PodGridContentItem } from './pod-grid-content-item';
import { PodGridItem } from './pod-grid-item';
import { PodGridItemHeader } from './pod-grid-item-header';


interface Props {
	settings: MyCpgPodsSettings;
}
export function DcPlanPod(props: Props) {

	const { settings } = props;
	const dcPlan = useSelector<TcsmStates, DcData>(state => state?.mycpgPodsState?.pods?.dc_data);
	const hidePod = dcPlan?.show_pod === YesNoIndicators.No;
	const noPlan = dcPlan?.content === PodContent.NOT_ENROLLED;
	const today = getCurrentFormattedDateNY(true);
	const routeMatch = useRouteMatch();

	if (hidePod) {
		return null;
	}

	const renderDC = () => {
		return (
			<PodGridContentItem>
				<p className='h3-styled'>{getCurrencyFormat(dcPlan?.data?.total_balance)}</p>
				<p className='grey-caption'>{settings?.balanceDateLabel?.replace('{date}', dcPlan?.data?.as_of_date || today)}</p>
			</PodGridContentItem>
		);
	};


	const renderContent = () => {

		if (noPlan) {
			return <div dangerouslySetInnerHTML={{ __html: settings?.noDcPlanMessage }} />;
		}

		return renderDC();
	};

	return (
		<PodGridItem>
			<PodGridItemHeader title={settings?.pensionPlanDcPodTitle}>
				<Link to={`${routeMatch?.path}?type=${MyCpgPodsTypes.DC}`}>{noPlan ? settings?.learnMoreText : settings?.seeMoreLinkText}</Link>
			</PodGridItemHeader>
			<PodGridContent>
				{renderContent()}
			</PodGridContent>
		</PodGridItem>
	);

}

